export default "__VITE_ASSET__BAiLJUbi__"